<template>
  <div class="grarantee-form-contanier">
    <Nav applyType="9100"></Nav>
    <Step :arr="arr" class="mb-6"></Step>
    <component
      :is="stepComnent"
      @updateStepStatus="updateStepStatus"
    ></component>
  </div>
</template>

<script>
import Step from '../../components/CA/Step'
import nav from '../../components/letter_nav/letter.nav'
import firstStepForm from './components/firstStepForm'

export default {
  name: 'applicationperformance',
  components: {
    firstStepForm,
    Nav: nav,
    Step,
  },
  data() {
    return {
      active: 1,
      stepComnent: 'firstStepForm',
      arr: [
        { icon: 1, span: '履约保函信息填写', status: 'finish', time: '' },
        { icon: 2, span: '履约保险保函信息确认', status: 'wait', time: '' },
        { icon: 3, span: '担保公司审核', status: 'wait', time: '' },
        { icon: 4, span: '支付', status: 'wait', time: '' },
        { icon: 5, span: '担保公司出函', status: 'wait', time: '' },
      ],
    }
  },
  methods: {
    updateStepStatus(active, name) {
      this.active = active || 1
      this.stepComnent = name || 'firstStepForm'
    },
  },
}
</script>

<style scoped>
.elSteps {
  padding: 10px 0;
}
</style>
